export default __webpack_public_path__ + "static/media/form_logo_word_dark.692a772e.svg";